export const SET_TRADE_OVERVIEW = 'trade_detail/SET_TRADE_OVERVIEW'
export const SET_TRADE_DETAIL_LOOKUPS = 'trade_detail/SET_TRADE_DETAIL_LOOKUPS'
